import * as Scrivito from "scrivito";
import { useEffect, useState } from "react";

export const useScrivitoObj = (name: string) => {
  const [obj, setObj] = useState<Scrivito.Obj | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    Scrivito.load(() =>
      Scrivito.Obj.where("_objClass", "equals", name).first(),
    ).then((res) => {
      setObj(res);
      setIsLoading(false);
    });
  }, [name]);

  return { obj, isLoading };
};
